import { map } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { VehicleType } from '../../../schemas/vehicle-type.schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';

const costProfileApiResponseSchema = z.object({
  profile: z.object({
    id: z.string(),
    name: z.string(),
  }),
});

/**
 * Returns cost profiles available for a specific vehicle type
 * @param vehicleType The vehicle type to get cost profiles for
 * @returns Collection of cost profiles
 */
export function getRoutingProfilesCostProfiles(
  this: unknown,
  vehicleType: VehicleType
) {
  const params = new URLSearchParams();
  params.append('vehicleType', vehicleType);

  const url = `${routingProfileServiceEnvironment.resolve(this).routingProfilesCostProfilesUrl}?${params.toString()}`;

  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(url, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: z.array(costProfileApiResponseSchema),
      })
    ),
    map((response) => ({
      ...response,
      data: response.data.map((profile) => ({
        id: profile.profile.id,
        name: profile.profile.name,
      })),
    }))
  );
}
